var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{attrs:{"width":"md"}},[_c('section-header',{attrs:{"title":_vm.slice.primary.title,"teaser":_vm.slice.primary.teaser}}),_vm._v(" "),_c('faq-grid',{attrs:{"faq":_vm.slice.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }